import { createSlice } from "@reduxjs/toolkit"
import { RootState, registerReducer, store } from "@core/store"

const STATE_KEY = "pr"
export const CONFIG_KEY = `${STATE_KEY}_state`

interface IState {}
type StateFromRoot = { [STATE_KEY]: IState }

const persistantState = localStorage.getItem(CONFIG_KEY)
const emptyState: IState = {}

const initialState: IState = persistantState
  ? JSON.parse(persistantState)
  : emptyState

export const prSlice = createSlice({
  name: "pr",
  initialState: initialState,
  reducers: {},
})
registerReducer(prSlice.name, prSlice.reducer)
store.subscribe(() => {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(store.getState().pr))
})

export const {} = prSlice.actions

export const getHrState = (state: RootState<StateFromRoot>) => state.pr
